export interface IDirectLineToken {
  token: string;
  conversationId: string;
  expires_in: number;
}

export enum MessageTypes {
  SetToken = 'SET_TOKEN',
  GetToken = 'GET_TOKEN',
}

export interface IMessage {
  type: MessageTypes;
}

export interface ISetTokenMessage extends IMessage {
  type: MessageTypes.SetToken;
  token: IDirectLineToken;
}

export interface IGetTokenMessage extends IMessage {
  type: MessageTypes.GetToken;
}
